exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col_form .input_wrapper[data-v-bed23666]{margin-top:10px;margin-left:0}.col_form .input_wrapper>div label[data-v-bed23666]{width:90px}\n", ""]);

// exports
